import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "SL_offerMLV_title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }


export default /*@__PURE__*/_defineComponent({
  __name: 'moduleSEProvideMaterial',
  props: {
  item: { type: Object, default: "" },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "SL_offerMaterialListView",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/ShadowTrainDetailPage?id=' + __props.item.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_image, {
        class: "img",
        src: __props.item.image,
        lazy: true
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(__props.item.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(__props.item.content), 1)
      ])
    ])
  ]))
}
}

})